import { SPECIALIST_CHAT_CLICK_SEGMENT, LOAD_PLAN_DETAILS } from './constants';

export const specialistChatClickSegment = ({ service, location, buttonClicked }) => {
  return {
    type: SPECIALIST_CHAT_CLICK_SEGMENT,
    meta: {
      analytics: [
        {
          eventType: 'track',
          eventPayload: {
            event: 'Specialist Chat Button Clicked',
            properties: {
              basePrice: service.basePrice,
              category: service.categoryId,
              imageUrl: service.image,
              isRemote: service.remote,
              name: service.name,
              partner: service.partner,
              price: service.listPrice.value,
              skuId: service.id,
              location,
              buttonClicked,
            },
          },
        },
      ],
    },
  };
};

export const loadPlanDetails = ({ plan }) => ({
  type: LOAD_PLAN_DETAILS,
  plan,
});
